/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// List of all possible order_component with display order defined
export const KEY_COMPONENT_ORDERED = [
    'group_leader_details',
    'group_leader_address',
    'group_size',
    'camper_info',
    'camping_equipment',
    'num_vehicles',
    'vehicle_info',
    'oprd_vehicles',
    'mode_of_travel',
    'access_point',
    'emergency_contact',
    'pass',
    'passes',
    'add_ons',
];

/* ********************
        PATHS
******************** */
export const NUM_OCCUPANTS_PATH = 'site_occupant.num_occupants';
export const PRIMARY_OCCUPANT_PATH = 'site_occupant.primary_occupant';

// group_leader_details
export const FIRST_NAME_PATH = 'site_occupant.primary_occupant.first_name';
export const LAST_NAME_PATH = 'site_occupant.primary_occupant.last_name';
export const EMAIL_PATH = 'site_occupant.primary_occupant.email';
export const PHONE_PATH = 'site_occupant.primary_occupant.phone';
export const POSTAL_CODE_PATH = 'site_occupant.primary_occupant.zip';

// campers information
export const CAMPER_INFORMATION = 'site_occupant.custom_order_details.camper_info';
// NOTE: Each field requires the camper index to be appended preceded by an underscore
export const CAMPER_INFORMATION_FIRST_NAME =
    'site_occupant.custom_order_details.camper_info.first_name';
export const CAMPER_INFORMATION_IS_MINOR =
    'site_occupant.custom_order_details.camper_info.is_minor';
export const CAMPER_INFORMATION_LAST_NAME =
    'site_occupant.custom_order_details.camper_info.last_name';
export const CAMPER_INFORMATION_POSTAL_CODE =
    'site_occupant.custom_order_details.camper_info.zip';

// group_leader_address
export const ADDRESS_PATH = 'site_occupant.custom_order_details.address';
export const STREET_ADDRESS_PATH =
    'site_occupant.custom_order_details.address.street_address';
export const APARTMENT_SUITE_ADDRESS_PATH =
    'site_occupant.custom_order_details.address.apt_num';
export const CITY_ADDRESS_PATH = 'site_occupant.custom_order_details.address.city';
export const STATE_ADDRESS_PATH = 'site_occupant.custom_order_details.address.state';
export const POSTAL_CODE_ADDRESS_PATH = 'site_occupant.custom_order_details.address.zip';
export const COUNTRY_ADDRESS_PATH = 'site_occupant.custom_order_details.address.country';
export const ALTERNATIVE_PHONE_ADDRESS_PATH =
    'site_occupant.custom_order_details.address.alternative_phone';

// group_size
export const GROUP_SIZE_BASE_PATH = 'site_occupant.custom_order_details.group_size';
export const IS_GROUP_SIZE_SAME_PATH =
    'site_occupant.custom_order_details.group_size.is_group_size_same';
export const SINGLE_GROUP_SIZE_PATH =
    'site_occupant.custom_order_details.group_size.group_size';

// camping_equipment
export const EQUIPMENT_BASE_PATH = 'site_occupant.selected_equipment';

// num_vehicles
export const NUM_VEHICLES = 'site_occupant.num_vehicles';
export const NUM_VEHICLES_BASE_PATH = 'site_occupant.custom_order_details.num_vehicles';
export const SINGLE_NUM_VEHICLES_PATH =
    'site_occupant.custom_order_details.num_vehicles.num_vehicles';
export const IS_NUM_VEHICLES_SAME_PATH =
    'site_occupant.custom_order_details.num_vehicles.is_num_vehicles_same';

// vehicle_info
export const VEHICLE_MAKE_PATH =
    'site_occupant.custom_order_details.vehicle_information.make';
export const VEHICLE_MODEL_PATH =
    'site_occupant.custom_order_details.vehicle_information.model';
export const VEHICLE_COLOR_PATH =
    'site_occupant.custom_order_details.vehicle_information.color';
export const VEHICLE_LICENSE_STATE_PATH =
    'site_occupant.custom_order_details.vehicle_information.license_state';
export const VEHICLE_LICENSE_NUMBER_PATH =
    'site_occupant.custom_order_details.vehicle_information.license_number';
export const VEHICLE_IS_AWD_PATH =
    'site_occupant.custom_order_details.vehicle_information.is_awd';
export const VEHICLE_IS_HIGH_CLEARANCE_PATH =
    'site_occupant.custom_order_details.vehicle_information.is_high_clearance';
export const VEHICLE_IS_INTERNATIONAL_PATH =
    'site_occupant.custom_order_details.vehicle_information.is_international';

// mode_of_travel
export const MODE_OF_TRAVEL_PATH = 'site_occupant.custom_order_details.mode_of_travel';

// access_point
export const ENTRY_POINT_PATH =
    'site_occupant.custom_order_details.launch_point.launch_point';
export const EXIT_POINT_PATH =
    'site_occupant.custom_order_details.take_out_point.take_out_point';

// emergency_contact
export const EMERGENCY_CONTACT_PATH =
    'site_occupant.custom_order_details.emergency_contact';
export const EMERGENCY_CONTACT_FIRST_NAME_PATH =
    'site_occupant.custom_order_details.emergency_contact.first_name';
export const EMERGENCY_CONTACT_LAST_NAME_PATH =
    'site_occupant.custom_order_details.emergency_contact.last_name';
export const EMERGENCY_CONTACT_PHONE_PATH =
    'site_occupant.custom_order_details.emergency_contact.phone';

// pass
export const PASS_BASE_PATH = 'site_occupant.pass';
export const PASS_TYPE_PATH = 'site_occupant.pass.pass_type';
export const PASS_NUMBER_PATH = 'site_occupant.pass.pass_number';
export const PASSES_TYPE_PATH = 'site_occupant.passes[$index].pass_type';
export const PASSES_NUMBER_PATH = 'site_occupant.passes[$index].pass_number';

// vehicles details
export const VEHICLES_PATH = 'site_occupant.vehicles';
export const VEHICLE_TYPE = {
    Standard: 'standard',
    Motorcyle: 'motorcycle',
};

// reservation options
export const OVERRIDE_RULES_PATH = 'reservation_options.override_rules';

// supplemental camping
export const SUPPLEMENTAL_SELECTION_PATH = 'reservation_options.supplemental_selection';
export const SUPPLEMENTAL_SELECTION_TYPES = {
    NotReserve: 'not_reserve',
    PickDaysIndividually: 'pick_days_individually',
    WholeStay: 'whole_stay',
};
export const SUPPLEMENTAL_SELECTION_MAX_ITEMS = 5;
export const SUPPLEMENTAL_VALIDATION_TYPES = {
    InvalidDates: 'INVALID_DATES',
    MissingType: 'MISSING_TYPE',
};

// rentals reservations
export const QUANTITY = 'quantity';
export const RESOURCE_ID = 'resource_id';

export const campgroundsWithoutVehicles = ['273757'];

export const APOS_LAUNCH_POINTS = [
    {
        label: 'Ashland',
        value: 'Ashland',
    },
    {
        label: 'Bayfield',
        value: 'Bayfield',
    },
    {
        label: 'Cornucopia',
        value: 'Cornucopia',
    },
    {
        label: 'Duluth',
        value: 'Duluth',
    },
    {
        label: 'Little Sand Bay',
        value: 'Little Sand Bay',
    },
    {
        label: 'Madeline Island',
        value: 'Madeline Island',
    },
    {
        label: 'Meyers Beach',
        value: 'Meyers Beach',
    },
    {
        label: 'Other',
        value: 'Other',
    },
    {
        label: 'Port Wing',
        value: 'Port Wing',
    },
    {
        label: 'Red Cliff',
        value: 'Red Cliff',
    },
    {
        label: 'Washburn',
        value: 'Washburn',
    },
];

export const OKEFENOKEE_LAUNCH_POINTS = [
    {
        label: 'Kingfisher Landing (KF)',
        value: 'KF',
    },
    {
        label: 'Suwannee Canal Recreation Area (SCRA)',
        value: 'SCRA',
    },
    {
        label: 'Stephen C. Foster State Park (SFSP)',
        value: 'SFSP',
    },
];

export const LAUNCH_POINT_MAP = {
    251865: APOS_LAUNCH_POINTS,
    250860: OKEFENOKEE_LAUNCH_POINTS,
};

export const FEE_TYPES = {
    0: 'CLIN',
    1: 'TRANSACTION',
    2: 'USE',
    3: 'TICKET',
    4: 'ATTRIBUTE',
    5: 'POS',
    6: 'TAX',
    7: 'DISCOUNT',
    8: 'DEPOSIT',
    9: 'USENOREFUND',
    10: 'PERCENT_DISCOUNT', //for tribal pass or military fee waiver
    11: 'LOS_DISCOUNT', //lenght of stay discount
};

export const FEE_TYPES_ORDER = [
    'USE',
    'ATTRIBUTE',
    'USENOREFUND',
    'DEPOSIT',
    'POS',
    'TRANSACTION',
    'DISCOUNT',
    'PERCENT_DISCOUNT',
    'LOS_DISCOUNT',
    'TAX',
];

export const FEE_SUPPLEMENTAL_ITEM = 'Supplemental Camping Use Fee';

export const OKEF_SEASONAL_MAX_STAY_NIGHTS = {
    Peak: 2,
    'Off Peak': 4,
    'Walk In': 4,
    Transition: 4,
};

export const CAMPSITE_VS_ACCOUNT_PASS_MAP = {
    'Interagency Access Pass': 'Interagency Access Pass',
    'Interagency Annual Senior Pass': 'Interagency Senior Pass',
    'Interagency Lifetime Senior Pass': 'Lifetime Senior Pass',
    'Golden Access Pass': 'Golden Age Access Pass',
    'Golden Age Pass': 'Golden Age Senior Pass',
};

// List of equipments in 'Allowed Equipments' that counts as 'vehicle'
export const VEHICLE_LIST = [
    'RV/Motorhome',
    'RV',
    'Caravan/Camper Van',
    'Pickup Camper',
    'Car',
    'Vehicle',
];

/* ********************
        PASSES
******************** */
export const GOLDEN_ACCESS_PASS = 'Golden Access Pass';
export const GOLDEN_AGE_PASS = 'Golden Age Pass';
export const INTERAGENCY_ACCESS_PASS = 'Interagency Access Pass';
export const INTERAGENCY_ANNUAL_SENIOR_PASS = 'Interagency Annual Senior Pass';
export const INTERAGENCY_LIFETIME_SENIOR_PASS = 'Interagency Lifetime Senior Pass';
export const MILITARY_PASS = 'Military Fee Waiver';
export const TRIBAL_WAIVER = 'Tribal Discount';

/* List of pass types that doesn't require an associated pass number to apply */
export const PASSES_WITHOUT_PASS_NUMBER = [MILITARY_PASS, TRIBAL_WAIVER];

/* campsite types that doesn't allow passes to be applied */
export const CAMPSITE_TYPES_WITHOUT_PASSES = ['group', 'cabin', 'yurt', 'lookout'];
